/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Automatic_Transcription_TitleInputs */



/**
* | output |
* | --- |
* | "Automatic Transcription" |
*
* @param {Toolbar_Secondary_Automatic_Transcription_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_automatic_transcription_title = /** @type {((inputs?: Toolbar_Secondary_Automatic_Transcription_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Automatic_Transcription_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription Automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Transkription")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическая транскрипция")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripción automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动转录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動転写")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित प्रतिलेखन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcrição automática")
	return /** @type {LocalizedString} */ ("Automatic Transcription")
});